import {
    buttonClassName,
    profileNavigationClassNames,
    pxArrayToRem,
    pxToRem,
    type StyleRule,
} from '@archipro-design/aria';
import { MOBILE_TOP_NAV_FULL_LOGO_HEIGHT } from '@archipro-website/top-navigation';

export const MobileProfileNavigationWrapper: StyleRule = ({ theme }) => ({
    [`& > div`]: {
        // this is to respect the z-index of rocco / tailwind
        zIndex: theme.siteVariables.zIndexes.topNav - 1,
    },
    [`& .ui-animation`]: {
        padding: 0,
        height: pxToRem(64),
    },
    [`& .${profileNavigationClassNames.itemContainer}`]: {
        paddingRight: pxToRem(10),
        [`& .${buttonClassName}:last-child`]: {
            marginRight: pxToRem(0),
        },
    },
});

export const MobileProfileNavigationContainer: StyleRule<{
    isSticky: boolean;
}> = ({ theme, isSticky }) => ({
    position: isSticky ? 'fixed' : 'absolute',
    top: isSticky ? MOBILE_TOP_NAV_FULL_LOGO_HEIGHT : 'unset',
    padding: pxArrayToRem([10, 0, 10, 10]),
    backgroundColor: theme.siteVariables.colorScheme.default?.background,
    width: '100%',
});

export const PotmMobileNavigationWrapper: StyleRule<{}> = () => ({
    position: 'relative',
    padding: pxArrayToRem([16, 0]),
});
export const PotmMobileFilterWrapper: StyleRule<{}> = () => ({
    padding: pxArrayToRem([24, 12]),
});
export const PotmMobileDescriptionWrapper: StyleRule<{}> = () => ({
    padding: pxArrayToRem([0, 12]),
    lineHeight: pxToRem(18),
    color: '#6E6E71',
    WebkitBoxOrient: 'vertical',
});
